import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.string.includes.js';
import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client';
import { inject } from 'inversify';
import { Envs } from '../envs.js';

let SaveAssetProgress = class SaveAssetProgress {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(payload) {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise((resolve, reject) => {
        this.httpClient.request({
          url: `${Envs.BFF_MEMBERS_AREA_URL}/assets/progress`,
          method: HttpMethod.PATCH,
          body: payload,
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (![HttpStatusCode.NO_CONTENT, HttpStatusCode.OK].includes(response.statusCode)) {
            return reject(`Ocorreu um erro ao salvar o progresso ${payload.assetId}`);
          }
          return resolve(true);
        });
      });
    });
  }
};
SaveAssetProgress = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], SaveAssetProgress);

export { SaveAssetProgress };
